/* ============================================================
   MIGA — Make Italy Great Again — Shopify Theme Custom JS
   Vanilla JS only — no dependencies
   ============================================================ */

(function () {
  'use strict';

  /* ─── i18n (strings injected from layout via window.migaI18n) ─── */
  var T = window.migaI18n || {};
  function t(key, fallback) { return (T && T[key]) ? T[key] : fallback; }

  /* ─── LIFESTYLE CAROUSEL ─────────────────────────────────────── */
  function initLifestyleCarousel() {
    // Scoped per instance: the carousel now appears on both the homepage and
    // product pages, so a page can hold more than one.
    document.querySelectorAll('[data-miga-lifestyle]').forEach(setupCarousel);
  }

  function setupCarousel(root) {
    var track = root.querySelector('[data-miga-lifestyle-track]');
    if (!track) return;

    var tiles = track.querySelectorAll('.miga-tile');
    if (tiles.length < 3) return;

    var groupSize = tiles.length / 3; // track is rendered 3x for a seamless loop
    var prevBtn = root.querySelector('[data-miga-lifestyle-prev]');
    var nextBtn = root.querySelector('[data-miga-lifestyle-next]');
    var autoTimer = null;

    function groupWidth() {
      return tiles[groupSize].offsetLeft - tiles[0].offsetLeft;
    }

    function tileStep() {
      return tiles[1].offsetLeft - tiles[0].offsetLeft;
    }

    // Start scrolled into the middle copy so both prev and next have room to wrap.
    if (track.scrollLeft < 1) {
      track.scrollLeft = groupWidth();
    }

    function normalize() {
      var gw = groupWidth();
      if (track.scrollLeft >= gw * 2 - 2) {
        track.scrollLeft -= gw;
      } else if (track.scrollLeft <= 2) {
        track.scrollLeft += gw;
      }
    }

    function shift(dir) {
      track.scrollBy({ left: dir * tileStep(), behavior: 'smooth' });
    }

    function startAuto() {
      stopAuto();
      autoTimer = setInterval(function () { shift(1); }, 3500);
    }
    function stopAuto() {
      if (autoTimer) clearInterval(autoTimer);
    }

    var normalizeTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(normalize, 120);
    });

    if (nextBtn) nextBtn.addEventListener('click', function () { shift(1); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { shift(-1); startAuto(); });

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('touchstart', stopAuto, { passive: true });
    root.addEventListener('touchend', startAuto, { passive: true });

    startAuto();
  }

  /* ─── GALLERY ───────────────────────────────────────────────── */
  function initGallery() {
    const gallery = document.querySelector('[data-miga-gallery]');
    if (!gallery) return;

    const imgs = gallery.querySelectorAll('.miga-gallery__img');
    const thumbs = gallery.querySelectorAll('.miga-thumb');
    const hint = gallery.querySelector('.miga-gallery__hint');
    const prevBtn = gallery.querySelector('.miga-gallery__arrow--prev');
    const nextBtn = gallery.querySelector('.miga-gallery__arrow--next');
    const stage = gallery.querySelector('.miga-gallery__stage');

    // Start from whichever slide Liquid marked active (the selected variant's
    // photo), otherwise prev/next would step from the wrong index.
    let current = 0;
    imgs.forEach(function (img, idx) {
      if (img.classList.contains('is-active')) current = idx;
    });
    let hoverInterval = null;

    function showSlide(i) {
      current = ((i % imgs.length) + imgs.length) % imgs.length;
      imgs.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === current);
      });
      thumbs.forEach(function (th, idx) {
        th.classList.toggle('is-active', idx === current);
      });
    }

    thumbs.forEach(function (th, idx) {
      th.addEventListener('click', function () { showSlide(idx); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); });

    // Auto-rotate only where a real pointer can hover. On touch screens the
    // hint is meaningless and mouseenter fires on tap, which would hijack the
    // gallery — so it's skipped entirely there (the hint is hidden via CSS).
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (stage && canHover) {
      stage.addEventListener('mouseenter', function () {
        if (hint) hint.textContent = t('rotating', 'rotating');
        hoverInterval = setInterval(function () { showSlide(current + 1); }, 1600);
      });
      stage.addEventListener('mouseleave', function () {
        if (hint) hint.textContent = t('hoverToRotate', 'hover to rotate');
        clearInterval(hoverInterval);
        hoverInterval = null;
      });
    }

    // Swipe left/right through the photos on touch devices.
    if (stage) {
      var swipeX = 0;
      var swipeY = 0;
      var swiping = false;

      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        swipeX = e.touches[0].clientX;
        swipeY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;

        var touch = e.changedTouches[0];
        if (!touch) return;

        var dx = touch.clientX - swipeX;
        var dy = touch.clientY - swipeY;

        // Ignore mostly-vertical moves so page scrolling still works.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        showSlide(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    // Exposed so the variant picker can jump to a variant's photo when available.
    window.migaGalleryGoTo = function (imageId) {
      var idx = -1;
      imgs.forEach(function (img, i) {
        if (String(img.dataset.migaImageId) === String(imageId)) idx = i;
      });
      if (idx > -1) showSlide(idx);
    };
  }

  /* ─── VARIANT PICKER ─────────────────────────────────────────── */
  function initVariantPicker() {
    var root = document.querySelector('[data-miga-variants]');
    var jsonEl = document.querySelector('[data-miga-variants-json]');
    if (!root || !jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var groups = root.querySelectorAll('.miga-variant-group');

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function selectedOptions() {
      var opts = [];
      groups.forEach(function (group, idx) {
        var active = group.querySelector('.miga-variant-pill.is-active');
        opts[idx] = active ? active.dataset.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return (opts[0] == null || v.option1 === opts[0]) &&
          (opts[1] == null || v.option2 === opts[1]) &&
          (opts[2] == null || v.option3 === opts[2]);
      })[0];
    }

    function applyVariant(variant) {
      if (!variant) return;

      var atc = document.querySelector('[data-miga-add-to-cart]');
      var priceWrap = document.querySelector('[data-miga-unit-price]');
      var priceNow = document.querySelector('[data-miga-price-now]');
      var priceWas = document.querySelector('[data-miga-price-was]');

      if (priceWrap) priceWrap.dataset.migaUnitPrice = variant.price / 100;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      if (atc) {
        atc.dataset.migaVariantId = variant.id;
        var qtyEl = document.querySelector('[data-miga-qty-val]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (variant.available) {
          atc.disabled = false;
          atc.textContent = t('add', 'Aggiungi') + ' · ' + formatMoney(variant.price * qty);
        } else {
          atc.disabled = true;
          atc.textContent = t('soldOut', 'Esaurito');
        }
      }

      if (variant.featured_image && variant.featured_image.id && window.migaGalleryGoTo) {
        window.migaGalleryGoTo(variant.featured_image.id);
      }
    }

    root.querySelectorAll('[data-miga-variant-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.miga-variant-group');
        group.querySelectorAll('.miga-variant-pill').forEach(function (p) {
          p.classList.remove('is-active');
        });
        pill.classList.add('is-active');
        var label = group.querySelector('[data-miga-variant-selected]');
        if (label) label.textContent = pill.dataset.value;

        applyVariant(findVariant(selectedOptions()));
      });
    });
  }

  /* ─── QUANTITY SELECTOR ─────────────────────────────────────── */
  function initQuantity() {
    var containers = document.querySelectorAll('[data-miga-qty]');
    containers.forEach(function (container) {
      var minusBtn = container.querySelector('[data-miga-qty-minus]');
      var plusBtn = container.querySelector('[data-miga-qty-plus]');
      var display = container.querySelector('[data-miga-qty-val]');
      if (!minusBtn || !plusBtn || !display) return;

      function getQty() {
        return parseInt(display.textContent, 10) || 1;
      }

      function setQty(val) {
        val = Math.max(1, Math.min(9, val));
        display.textContent = val;
        // Re-trigger pop animation
        display.style.animation = 'none';
        display.offsetHeight; // reflow
        display.style.animation = '';
        // Sync all qty displays & update ATC buttons
        syncQuantity(val);
      }

      minusBtn.addEventListener('click', function () { setQty(getQty() - 1); });
      plusBtn.addEventListener('click', function () { setQty(getQty() + 1); });
    });
  }

  function syncQuantity(qty) {
    // Update all qty displays
    document.querySelectorAll('[data-miga-qty-val]').forEach(function (el) {
      el.textContent = qty;
    });
    // Update ATC button text
    var priceEl = document.querySelector('[data-miga-unit-price]');
    if (!priceEl) return;
    var unitPrice = parseFloat(priceEl.dataset.migaUnitPrice);
    var total = (unitPrice * qty).toFixed(2).replace('.', ',');

    document.querySelectorAll('[data-miga-atc-text]').forEach(function (el) {
      el.textContent = t('add', 'Aggiungi') + ' \u00b7 \u20ac' + total;
    });
  }

  // Present only when Cart type is "Drawer"; exposes Dawn's renderContents.
  function getCartDrawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  // Swaps #CartDrawer's innerHTML from a cart/add.js or cart/change.js
  // response's `sections.cart-drawer` payload, without calling
  // cart-drawer.renderContents() — that also opens the drawer, which is
  // wrong for actions (upsell add, protection toggle) that happen while
  // it's already open and shouldn't visually "re-open" it.
  function refreshCartDrawerMarkup(data) {
    if (!data || !data.sections || !data.sections['cart-drawer']) return;
    var incomingDoc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');

    var incoming = incomingDoc.querySelector('#CartDrawer');
    var current = document.querySelector('#CartDrawer');
    if (incoming && current) current.innerHTML = incoming.innerHTML;

    // Dawn toggles "is-empty" on <cart-drawer> itself, outside #CartDrawer
    // — the innerHTML swap above never touches it. Without this, a custom
    // AJAX flow that empties the cart (e.g. the shipping-protection orphan
    // guard) leaves the drawer showing neither the normal contents nor the
    // "cart is empty" message: .cart-drawer__warnings stays display:none
    // (that rule keys off :not(.is-empty)) while the contents are gone.
    var incomingDrawerEl = incomingDoc.querySelector('cart-drawer');
    var currentDrawerEl = document.querySelector('cart-drawer');
    if (incomingDrawerEl && currentDrawerEl) {
      currentDrawerEl.classList.toggle('is-empty', incomingDrawerEl.classList.contains('is-empty'));
    }
  }

  function updateCartCountBadge() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-miga-cart-count]').forEach(function (badge) {
          badge.textContent = cart.item_count;
        });
      });
  }

  // Bundle add-ons (Simple Bundles & Kits' "infinite options" app block)
  // render plain <select name="properties[...]"> controls into
  // .miga-bundle-options. They're line item properties, not variants — this
  // theme's add-to-cart posts JSON directly instead of submitting the
  // product form, so without collecting them here the customer's picks are
  // silently dropped and the cart line shows the bundle name with nothing
  // under it. Empty values are skipped so an unanswered optional select
  // doesn't create a blank property row in the cart.
  function collectLineItemProperties() {
    var properties = {};
    document
      .querySelectorAll('.miga-bundle-options [name^="properties["]')
      .forEach(function (field) {
        if (field.type === 'checkbox' && !field.checked) return;
        if (field.type === 'radio' && !field.checked) return;
        var name = field.name.replace(/^properties\[/, '').replace(/\]$/, '');
        var value = (field.value || '').trim();
        if (!name || !value) return;
        // Simple Bundles' own placeholder option — treat as "not chosen".
        if (value === 'Please select an option') return;
        properties[name] = value;
      });
    return properties;
  }

  /* ─── ADD TO CART ───────────────────────────────────────────── */
  function initAddToCart() {
    document.querySelectorAll('[data-miga-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.migaVariantId;
        var qtyEl = document.querySelector('[data-miga-qty-val]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

        btn.disabled = true;
        btn.textContent = t('adding', 'Aggiungendo...');

        // Ask for the drawer's sections so it can be filled and opened in the
        // same round trip. Only this handler opens the drawer — the qty +/-
        // steppers just change a local number and never touch the cart.
        var drawer = getCartDrawer();
        var lineItem = { id: parseInt(variantId, 10), quantity: qty };
        var properties = collectLineItemProperties();
        if (Object.keys(properties).length > 0) lineItem.properties = properties;

        var body = { items: [lineItem] };
        if (drawer) {
          body.sections = ['cart-drawer', 'cart-icon-bubble'];
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Errore aggiunta al carrello');
          return res.json();
        })
        .then(function (data) {
          btn.textContent = t('added', 'Aggiunto!');
          // Dawn's own method: swaps the drawer's markup, then opens it.
          // (Intentional here — this is the actual "add to cart" action, as
          // opposed to the upsell/protection toggles, which shouldn't
          // re-open a drawer that's already open.)
          if (drawer && data && data.sections) drawer.renderContents(data);
          return updateCartCountBadge();
        })
        .then(function () {
          setTimeout(function () {
            btn.disabled = false;
            var priceEl = document.querySelector('[data-miga-unit-price]');
            var qtyEl2 = document.querySelector('[data-miga-qty-val]');
            if (priceEl && qtyEl2) {
              var total = (parseFloat(priceEl.dataset.migaUnitPrice) * parseInt(qtyEl2.textContent, 10)).toFixed(2).replace('.', ',');
              btn.textContent = t('add', 'Aggiungi') + ' \u00b7 \u20ac' + total;
            } else {
              btn.textContent = t('addToCart', 'Aggiungi al carrello');
            }
          }, 1500);
        })
        .catch(function (err) {
          console.error(err);
          btn.textContent = t('errorRetry', 'Errore — Riprova');
          btn.disabled = false;
          setTimeout(function () {
            var priceEl = document.querySelector('[data-miga-unit-price]');
            var qtyEl2 = document.querySelector('[data-miga-qty-val]');
            if (priceEl && qtyEl2) {
              var total = (parseFloat(priceEl.dataset.migaUnitPrice) * parseInt(qtyEl2.textContent, 10)).toFixed(2).replace('.', ',');
              btn.textContent = t('add', 'Aggiungi') + ' \u00b7 \u20ac' + total;
            }
          }, 2000);
        });
      });
    });
  }

  /* ─── SPLASH PAGE ───────────────────────────────────────────── */
  function initSplash() {
    var splash = document.querySelector('[data-miga-splash]');
    if (!splash) return;

    var link = splash.dataset.migaSplashLink;

    splash.addEventListener('click', function () {
      splash.classList.add('miga-splash--exit');
      // Create wipe overlay
      var wipe = document.createElement('div');
      wipe.className = 'miga-wipe';
      document.body.appendChild(wipe);
      setTimeout(function () {
        window.location.href = link;
      }, 600);
    });

    splash.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        splash.click();
      }
    });
  }

  /* ─── VIEWPORT HEIGHT VAR (in-app browser fallback) ───────────── */
  // Publishes 1% of the real visible height as --miga-vh, the middle rung of
  // the cart drawer's height fallback chain (see "cart-drawer.drawer" in
  // miga-custom.css). Only WebViews too old for dvh actually use it; newer
  // ones take 100dvh and ignore this entirely.
  //
  // Debounced, and ignores changes under ~24px: the in-app toolbars in
  // Instagram/TikTok animate their show/hide, firing a burst of resize
  // events at intermediate heights. Reacting to each one is what makes a
  // drawer visibly stutter mid-gesture, so only a settled, toolbar-sized
  // change counts.
  function initViewportHeightVar() {
    var root = document.documentElement;
    var lastPx = 0;
    var timer;

    function apply() {
      var height = window.innerHeight;
      if (Math.abs(height - lastPx) < 24) return;
      lastPx = height;
      root.style.setProperty('--miga-vh', height / 100 + 'px');
    }

    apply();

    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    }, { passive: true });

    // Orientation changes report the pre-rotation height for a moment on
    // iOS, so re-read once the new layout has settled.
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        lastPx = 0;
        apply();
      }, 300);
    });
  }

  /* ─── HOME NAV — solid on scroll (fades in/out) ───────────────── */
  function initHomeNavScroll() {
    if (!document.body.classList.contains('template-home')) return;

    var threshold = 60;
    var ticking = false;

    function update() {
      document.body.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ─── CART UPSELL — add via AJAX, no reload ──────────────────── */
  function initCartUpsell() {
    // Delegated: the button lives inside .js-contents, which Dawn replaces
    // wholesale on every cart update, so a direct listener wouldn't survive.
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-miga-cart-upsell-add]');
      if (!btn) return;

      e.preventDefault();
      if (btn.disabled) return;

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      // The same carousel renders in two places. Inside the drawer we refresh
      // the drawer's own markup; on the cart page we refresh that page's
      // sections. Either way nothing re-opens — the drawer is already open.
      var inDrawer = !!btn.closest('cart-drawer');
      var drawerEl = inDrawer ? getCartDrawer() : null;

      var itemsEl = document.getElementById('main-cart-items');
      var footerEl = document.getElementById('main-cart-footer');
      var sections = [];
      if (drawerEl) {
        sections.push('cart-drawer', 'cart-icon-bubble');
      } else {
        if (itemsEl) sections.push(itemsEl.dataset.id);
        if (footerEl) sections.push(footerEl.dataset.id);
      }

      // The carousel's add control is a 30px "+" — spelling out "Adding..."
      // there would overflow it, so compact buttons get symbols instead.
      var isCompact = btn.classList.contains('miga-cart-card__add');

      btn.disabled = true;
      btn.textContent = isCompact ? '·' : t('cartAdding', 'Aggiungendo...');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function (data) {
          if (!data.sections) return updateCartCountBadge();

          if (drawerEl) {
            // Doesn't call renderContents() — that also opens the drawer,
            // wrong here since it's already open.
            refreshCartDrawerMarkup(data);
          } else {
            // Swap the same .js-contents nodes Dawn's own cart.js targets.
            if (itemsEl && data.sections[itemsEl.dataset.id]) {
              replaceContents(itemsEl, data.sections[itemsEl.dataset.id], '.js-contents');
            }
            if (footerEl && data.sections[footerEl.dataset.id]) {
              replaceContents(footerEl, data.sections[footerEl.dataset.id], '.js-contents');
            }
          }
          return updateCartCountBadge();
        })
        .catch(function (err) {
          console.error(err);
          btn.disabled = false;
          btn.textContent = isCompact ? '+' : t('cartErrorRetry', 'Errore — Riprova');
        });
    });
  }

  /* ─── NEWSLETTER POPUP ───────────────────────────────────────── */

  // Set by initNewsletterPopup so the floating re-open tab can drive the
  // very same popup instance rather than growing a second implementation
  // of open/close that could drift out of step with it.
  var openNewsletterPopup = null;

  var NL_SUBSCRIBED_KEY = 'migaNlSubscribed';

  function nlSubscribedThisSession() {
    try {
      return sessionStorage.getItem(NL_SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function initNewsletterPopup() {
    var root = document.querySelector('[data-miga-newsletter]');
    if (!root) return; // absent for logged-in customers

    var SESSION_KEY = 'migaNlSeen';
    var COOKIE = 'miga_nl_dismissed';
    var DAYS = 30;

    function hasCookie(name) {
      return document.cookie.split(';').some(function (c) {
        return c.trim().indexOf(name + '=') === 0;
      });
    }

    function setCookie(name, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    function seenThisSession() {
      try {
        return sessionStorage.getItem(SESSION_KEY) === '1';
      } catch (e) {
        return false; // private mode: fall back to the cookie alone
      }
    }

    function markSession() {
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch (e) { /* ignore */ }
    }

    var box = root.querySelector('.miga-nl__box');
    var form = root.querySelector('.miga-nl__form');
    var done = root.querySelector('[data-miga-nl-done]');
    var errorEl = root.querySelector('[data-miga-nl-error]');
    var introStep = root.querySelector('[data-miga-nl-step="intro"]');
    var emailStep = root.querySelector('[data-miga-nl-step="email"]');
    var lastFocused = null;

    // Two screens in one dialog: the offer, then the email field. Both live
    // inside the same {% form %} — swapping which is hidden costs nothing
    // and keeps the single native submit Shopify's CAPTCHA depends on.
    function showStep(name) {
      if (!introStep || !emailStep) return; // success screen: neither exists
      var wantEmail = name === 'email';
      introStep.hidden = wantEmail;
      emailStep.hidden = !wantEmail;
      if (wantEmail) {
        var field = emailStep.querySelector('input[type="email"]');
        if (field) field.focus();
      }
    }

    // Signup is a native form post (see miga-newsletter-popup.liquid — the
    // CAPTCHA token Shopify requires only rides along with a real browser
    // submit), so Shopify reloads this page with the outcome baked into the
    // markup. Either of these blocks existing means the visitor just
    // submitted and is waiting to hear back, so the popup reopens
    // immediately rather than on the usual timer — and regardless of the
    // cookie/session checks below, which would otherwise swallow the reply.
    var postedSuccessfully = !!done;
    var hasServerError = !!errorEl;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      markSession();
      // Reflow, then add the class synchronously. requestAnimationFrame
      // used to gate this, but rAF is throttled or skipped outright while
      // the tab is backgrounded — and since `is-open` is what carries the
      // opacity, a skipped frame left the popup unhidden yet invisible.
      // Reading offsetHeight flushes layout so the transition still has a
      // start value to animate from.
      void root.offsetHeight;
      root.classList.add('is-open');
      // Always back to the offer, even if a previous visit got as far as
      // the email field without finishing — the exception is a submission
      // Shopify bounced, where step 2 has to be showing for its error to
      // be read at all.
      showStep(hasServerError ? 'email' : 'intro');
      // Lets the floating tab get out of the way without polling.
      document.dispatchEvent(new CustomEvent('miga:newsletter-open'));
    }

    function close() {
      root.classList.remove('is-open');
      setCookie(COOKIE, DAYS);
      setTimeout(function () {
        root.hidden = true;
        // Announced only once the popup is genuinely gone. Firing it up
        // front instead would have the floating tab check "is the popup
        // open?" during the 260ms fade-out, see hidden still false, and
        // decline to come back at all.
        document.dispatchEvent(new CustomEvent('miga:newsletter-close'));
      }, 260);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    // Published before the auto-open decision below, so the floating tab
    // still works on the visits where the popup deliberately stays shut.
    openNewsletterPopup = open;

    // The overlay and every "I'd rather pay full price" link share this
    // hook, so closing from either step goes through the same close() —
    // same cookie, same session flag as before.
    root.querySelectorAll('[data-miga-nl-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    var nextBtn = root.querySelector('[data-miga-nl-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { showStep('email'); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    // Keep clicks inside the dialog from reaching the overlay behind it.
    if (box) box.addEventListener('click', function (e) { e.stopPropagation(); });

    // Nothing to intercept on submit any more: the form posts natively so
    // Shopify can attach its CAPTCHA token and create the customer. The
    // browser's own type=email + required handles empty/malformed input
    // before the request leaves, and anything Shopify rejects comes back
    // rendered as .miga-nl__error.
    if (postedSuccessfully) {
      // Signed up: don't ask again for the full cookie window, and keep the
      // floating tab away for the rest of the session.
      setCookie(COOKIE, DAYS);
      try {
        sessionStorage.setItem(NL_SUBSCRIBED_KEY, '1');
      } catch (e) { /* private mode: the cookie still covers it */ }
    }

    // Tap the discount code to copy it. Clipboard access needs a secure
    // context and can be refused outright, so the fallback selects the code
    // instead — the visitor can still copy it by hand, and either way the
    // code is on screen to be read, which is the point of showing it here
    // rather than in the welcome email.
    var codeBtn = root.querySelector('[data-miga-nl-code]');
    if (codeBtn) {
      var codeHint = codeBtn.querySelector('[data-miga-nl-code-hint]');
      var hintIdleLabel = codeBtn.getAttribute('data-label-copy') || '';
      var hintDoneLabel = codeBtn.getAttribute('data-label-copied') || '';
      var hintTimer = null;

      function selectCode() {
        var valueEl = codeBtn.querySelector('[data-miga-nl-code-value]');
        if (!valueEl || !window.getSelection || !document.createRange) return;
        var range = document.createRange();
        range.selectNodeContents(valueEl);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }

      function reportCopied() {
        if (!codeHint || !hintDoneLabel) return;
        codeHint.textContent = hintDoneLabel;
        clearTimeout(hintTimer);
        hintTimer = setTimeout(function () {
          codeHint.textContent = hintIdleLabel;
        }, 2200);
      }

      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code') || '';
        if (!code) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(reportCopied, selectCode);
        } else {
          selectCode();
        }
      });
    }

    if (postedSuccessfully || hasServerError) {
      open();
      return;
    }

    // Already dismissed, or the theme editor: no auto-open. The close
    // handlers and openNewsletterPopup above stay wired either way — this
    // is exactly the state the floating re-open tab exists to serve.
    if (hasCookie(COOKIE) || seenThisSession()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    // Six seconds, not the couple it used to be: the store also runs a
    // cookie-consent banner that fires on arrival, and the two landing
    // together read as a wall of popups. This gives the visitor time to
    // deal with the banner and see the page first.
    setTimeout(open, 6000);
  }

  /* ─── NEWSLETTER — floating re-open tab ───────────────────────── */
  function initNewsletterReopenButton() {
    var tab = document.querySelector('[data-miga-nl-reopen]');
    if (!tab) return; // absent for logged-in customers, same as the popup

    var DISMISS_KEY = 'migaNlReopenDismissed';

    function dismissedThisSession() {
      try {
        return sessionStorage.getItem(DISMISS_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    // Already on the list, or waved this away earlier in the session:
    // never build it.
    if (nlSubscribedThisSession() || dismissedThisSession()) return;

    var popup = document.querySelector('[data-miga-newsletter]');

    function popupIsOpen() {
      return !!popup && !popup.hidden;
    }

    function show() {
      if (popupIsOpen()) return;
      tab.hidden = false;
      // Synchronous for the same reason as the popup's own open().
      void tab.offsetHeight;
      tab.classList.add('is-visible');
    }

    function hide() {
      tab.classList.remove('is-visible');
      setTimeout(function () { tab.hidden = true; }, 220);
    }

    tab.querySelector('[data-miga-nl-reopen-open]').addEventListener('click', function () {
      if (typeof openNewsletterPopup === 'function') openNewsletterPopup();
    });

    tab.querySelector('[data-miga-nl-reopen-dismiss]').addEventListener('click', function () {
      hide();
      try {
        sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (e) { /* ignore */ }
    });

    // Never both on screen at once — the popup covers the same offer.
    document.addEventListener('miga:newsletter-open', hide);
    document.addEventListener('miga:newsletter-close', function () {
      if (dismissedThisSession() || nlSubscribedThisSession()) return;
      show();
    });

    // Held back until after the popup's own 6s auto-open on a first visit
    // — appearing before it would mean sliding in only to be hidden again
    // by the miga:newsletter-open handler above — and so it isn't the
    // first thing competing for attention on arrival.
    setTimeout(show, 7500);
  }

  function replaceContents(rootEl, sectionHTML, selector) {
    var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var incoming = parsed.querySelector(selector);
    var current = rootEl.querySelector(selector);
    if (incoming && current) current.innerHTML = incoming.innerHTML;
  }

  /* ─── SHIPPING PROTECTION — orphan guard ───────────────────────
     Protection must never be the only thing left in the cart (it's an
     add-on, not something to ship on its own). Removes it automatically
     the moment that state is detected, from any surface: native
     cestino/quantity controls (drawer or /cart page), the drawer opening
     with stale state, or a fresh page load that already has it. */
  function initShippingProtectionOrphanGuard() {
    function removeOrphanedProtection(variantId) {
      var drawerEl = getCartDrawer();
      var itemsEl = document.getElementById('main-cart-items');
      var footerEl = document.getElementById('main-cart-footer');

      var sections = ['cart-icon-bubble'];
      if (drawerEl) sections.push('cart-drawer');
      if (itemsEl) sections.push(itemsEl.dataset.id);
      if (footerEl) sections.push(footerEl.dataset.id);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: String(variantId),
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.sections) return updateCartCountBadge();
          if (data.sections['cart-drawer']) refreshCartDrawerMarkup(data);
          if (itemsEl && data.sections[itemsEl.dataset.id]) {
            replaceContents(itemsEl, data.sections[itemsEl.dataset.id], '.js-contents');
          }
          if (footerEl && data.sections[footerEl.dataset.id]) {
            replaceContents(footerEl, data.sections[footerEl.dataset.id], '.js-contents');
          }
          return updateCartCountBadge();
        })
        .catch(function (err) { console.error(err); });
    }

    function checkCart(cart) {
      var variantId = window.migaShippingProtectionVariantId;
      if (!variantId || !cart || !cart.items || cart.items.length === 0) return;
      var onlyProtection = cart.items.every(function (item) {
        return item.variant_id === variantId;
      });
      if (onlyProtection) removeOrphanedProtection(variantId);
    }

    // Dawn's CartItems.updateQuantity() (cestino button, quantity input —
    // drawer AND /cart page both use it) publishes this after every
    // successful /cart/change.js. subscribe/PUB_SUB_EVENTS come from
    // pubsub.js/constants.js, both loaded before this file as plain
    // (non-module) scripts, so they're plain globals here too.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData) checkCart(event.cartData);
      });
    }

    // Wider safety net: every drawer open, and once on page load — covers
    // state left over from before this guard existed, or any path that
    // doesn't route through updateQuantity() above.
    document.addEventListener('cart-drawer:open', function () {
      fetch('/cart.js').then(function (res) { return res.json(); }).then(checkCart);
    });
    fetch('/cart.js').then(function (res) { return res.json(); }).then(checkCart);
  }

  /* ─── SHIPPING PROTECTION — popup + standalone checkbox row ───── */

  // The popup is anchored to the bottom of .drawer__footer, which already
  // sits flush with the bottom of the drawer — so it can't simply be moved
  // down to stop covering the estimated total (it would be clipped by
  // .drawer__inner's overflow:hidden). Instead the footer is grown by
  // however much the popup overlaps the total: the footer's bottom is
  // pinned to the drawer's, so extra padding-bottom pushes its contents
  // (checkbox, totals, tax note, checkout) up while the popup stays put at
  // its original size. The scrollable item list above absorbs the
  // difference. Measured rather than hard-coded because the popup's height
  // moves with how the copy wraps at a given width.
  var POPUP_TOTAL_GAP = 10;

  function popupFooterOf(popup) {
    return popup.closest('.drawer__footer');
  }

  function reserveRoomForPopup(popup) {
    var footer = popupFooterOf(popup);
    if (!footer) return;
    var totals = footer.querySelector('.totals');
    if (!totals) return;

    var overlap =
      totals.getBoundingClientRect().bottom + POPUP_TOTAL_GAP - popup.getBoundingClientRect().top;
    if (overlap <= 0) return;

    if (footer.dataset.migaBasePadBottom === undefined) {
      footer.dataset.migaBasePadBottom = getComputedStyle(footer).paddingBottom;
    }
    var base = parseFloat(footer.dataset.migaBasePadBottom) || 0;
    footer.style.paddingBottom = base + overlap + 'px';
  }

  function releaseRoomForPopup(popup) {
    var footer = popupFooterOf(popup);
    if (!footer) return;
    footer.style.paddingBottom = '';
    delete footer.dataset.migaBasePadBottom;
  }

  function initShippingProtection() {
    var POPUP_SESSION_KEY = 'migaShippingProtectionPromptSeen';

    function addProtection(variantId, done) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('shipping protection add failed');
          return res.json();
        })
        .then(function (data) {
          refreshCartDrawerMarkup(data);
          return updateCartCountBadge();
        })
        .then(function () { done(); })
        .catch(function (err) {
          console.error(err);
          done(err);
        });
    }

    // The popup is only present in the freshly-rendered markup when the
    // product isn't already in the cart (server-guarded in
    // cart-drawer.liquid). Shown at most once per session, the first time
    // the drawer genuinely opens — cart-drawer.js dispatches this event
    // from open(), which only runs on the icon click / real add-to-cart
    // path, never on a quantity +/- or the upsell/protection AJAX refreshes.
    document.addEventListener('cart-drawer:open', function () {
      var popup = document.querySelector('[data-miga-protection-popup]');
      if (!popup) return;

      try {
        if (sessionStorage.getItem(POPUP_SESSION_KEY)) return;
        sessionStorage.setItem(POPUP_SESSION_KEY, '1');
      } catch (e) {
        // Private mode / storage disabled: fall through and show it — a
        // popup that can reappear beats one that silently never can.
      }

      // No requestAnimationFrame here on purpose: it previously gated the
      // "is-visible" class (opacity/pointer-events), which meant a missed
      // or delayed frame left the popup technically unhidden but visually
      // invisible and unclickable — indistinguishable from "never shows".
      // Setting both synchronously trades the fade-in for a guarantee it's
      // actually visible and usable the instant the drawer opens.
      popup.hidden = false;
      popup.classList.add('is-visible');
      reserveRoomForPopup(popup);
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var dismissBtn = e.target.closest('[data-miga-protection-popup-dismiss]');
      if (dismissBtn) {
        var popup = dismissBtn.closest('[data-miga-protection-popup]');
        if (popup) {
          popup.classList.remove('is-visible');
          releaseRoomForPopup(popup);
          setTimeout(function () { popup.hidden = true; }, 220);
        }
        return;
      }

      var yesBtn = e.target.closest('[data-miga-protection-popup-yes]');
      if (!yesBtn) return;

      var variantId = parseInt(yesBtn.dataset.variantId, 10);
      if (!variantId) return;

      yesBtn.disabled = true;
      addProtection(variantId, function (err) {
        // On success #CartDrawer is fully replaced — the popup is guarded
        // out server-side now that the product is in the cart, so there's
        // nothing left to re-enable. Only the failure path needs it back.
        if (err) yesBtn.disabled = false;
      });
    });

    // Standalone checkbox row (footer, above the totals) — a real toggle:
    // stays visible and reflects the actual cart state either way, so
    // checking adds and unchecking removes again. Delegated: the row lives
    // inside #CartDrawer, replaced wholesale on every cart update.
    document.addEventListener('change', function (e) {
      var checkbox = e.target.closest('[data-miga-shipping-protection-checkbox]');
      if (!checkbox) return;

      var variantId = parseInt(checkbox.dataset.variantId, 10);
      if (!variantId) return;

      var wasChecked = checkbox.checked;
      checkbox.disabled = true;

      if (wasChecked) {
        addProtection(variantId, function (err) {
          if (err) {
            checkbox.checked = false;
            checkbox.disabled = false;
          }
        });
        return;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          // /cart/change.js validates top-level "id" against a string
          // pattern server-side — a JSON number here 400s ("expected
          // Integer to be a ..."), unlike /cart/add.js's items[].id which
          // accepts either. Must be a string.
          id: String(variantId),
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('shipping protection remove failed');
          return res.json();
        })
        .then(function (data) {
          refreshCartDrawerMarkup(data);
          return updateCartCountBadge();
        })
        .catch(function (err) {
          console.error(err);
          checkbox.checked = true;
          checkbox.disabled = false;
        });
    });
  }

  /* ─── INIT ALL ──────────────────────────────────────────────── */
  function init() {
    initViewportHeightVar();
    initSplash();
    initCartUpsell();
    initShippingProtection();
    initShippingProtectionOrphanGuard();
    initNewsletterPopup();
    initNewsletterReopenButton();
    initHomeNavScroll();
    initLifestyleCarousel();
    initGallery();
    initVariantPicker();
    initQuantity();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
